<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <!-- Breadcrumb Section -->
                <div class="breadcrumbnew">
                    <span @click="rediectList()">Deals</span>
                    <!-- <a v-if="contactsToShowStyle == 'grid'">Grid View</a> -->
                    <a>View Deal</a>
                </div>
                <button class="btn new-yes-button" @click="viewPipeline()">View Pipeline</button>
            </div>
            <div class="start-overflow">
                <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                        style="margin: 0 auto;" />
                </div>
                <!-- Deal Information Section -->
                <div v-else-if="!ajaxCallInProgress && deal_details" class="create-company-container w-100">
                    <div class="main-div">
                        <div class="create-company-header d-flex align-items-center justify-content-between text-flow">
                            <span class="fs-14  pl-3 text-white ml-3">{{deal_details.name || ""}} Deal
                                Information</span>
                            <span class="pointer ml-auto" v-if="EditDealInfo && selected_status == 'Active'">
                                <i class="icon fs-16 mr-2 icon-pencil text-white " v-if="userPermissions.deals.permitted_actions.edit" @click="hideEdit"></i>
                            </span>
                            <span v-if="updateDeal && userPermissions.deals.permitted_actions.edit" class="ml-auto">
                                <button @click="saveDeals" class="btn btn-new-save btn-wide px-2">Save</button>
                                <button @click="cancelDeals"
                                    class="btn btn-discard text-whte btn-wide ml-3 px-2">Discard</button>
                            </span>
                            <span class="pointer ml-2" @click="showDealInfo">
                                <i v-if="!show_Deal_info" class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="show_Deal_info">
                            <div class="d-flex justify-content-between align-items-center px-8 mt-3"
                                style="flex-wrap:wrap;">
                                <div>
                                    <input type="text" disabled v-model="selected_status" class="inputFieldNew mt-2"
                                        :class="{'active-deals': selected_status == 'Active', 'closed': selected_status == 'Closed', 'archive': selected_status == 'Archive'}">
                                </div>
                                <div class="d-flex">
                                    <button class="btn btn-new-primary btn-wide px-6" @click="moveToArchive"
                                        v-if="selected_status == 'Active' && userPermissions.deals.permitted_actions.archive"><i
                                            class="icon icon-arrow-down-bold-box text-white mr-2 fs-18"></i>Archive</button>
                                    <button
                                        v-if="selected_status == 'Archive' && userPermissions.deals.permitted_actions.retrieve"
                                        @click="moveToActive()" class="btn btn-new-save btn-wide px-6  ml-3"><i
                                            class="icon icon-send icon-direction text-white mr-2 fs-14"></i><span
                                            class="ml-2">Send to Active Deal</span></button>
                                    <button v-if="deal_details.stage !='deal_lost'"
                                        class="btn btn-bord-success bordrad-5px text-white text-capitalize ml-3 d-flex align-items-center">
                                        <i class="icon-thumb-up icon-tick-success mr-2"></i>
                                        {{deal_details.stage.replace(/_/g, " ")}}
                                    </button>
                                    <button v-if="deal_details.stage =='deal_lost'"
                                        class="btn btn-bord-lost bordrad-5px text-white text-capitalize ml-3 d-flex align-items-center">
                                        <i class="icon-thumb-down icon-hand-direction icon-tick-lost mr-2"></i>
                                        {{deal_details.stage.replace(/_/g, " ")}}
                                    </button>
                                </div>
                            </div>
                            <div class="row px-8">
                                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mt-4">
                                    <span class="fs-14 fw-600 text-secondary">
                                        Owner Name
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <input name="owner-name" v-validate="'required'" disabled
                                            class="inputFieldNew mt-3" type="text" v-model="deal_details.owner_name"
                                            placeholder="Enter Owner Name " />
                                        <i class="icon icon-tick-success icon-check-circle ml-2 mt-2"></i>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('owner-name')">
                                        {{errors.first('owner-name')}}
                                    </span>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mt-4">
                                    <span class="fs-14 fw-600 text-secondary">
                                        Contact Name
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <input name="contact-name" v-validate="'required'" disabled
                                            class="inputFieldNew mt-3" type="text" v-model="deal_details.contact_name"
                                            placeholder="Enter Contact Name " />
                                        <i v-if="deal_details.contact_name" class="icon icon-tick-success icon-check-circle ml-2 mt-2"></i>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-4">
                                    <span class="fs-14 fw-600 text-secondary">
                                        Customer Name
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <input name="customer-name" v-validate="'required'" disabled
                                            class="inputFieldNew mt-3" type="text" v-model="deal_details.customer_name"
                                            placeholder="Enter Customer Name " />
                                        <i v-if="deal_details.customer_name" class="icon icon-tick-success icon-check-circle ml-2 mt-2"></i>
                                    </div>
                                    <span class="invalid-feedback-form text-danger"
                                        v-show="errors.has('customer-name')">
                                        {{errors.first('customer-name')}}
                                    </span>
                                </div>
                            </div>
                            <div class="row px-8">
                                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mt-4">
                                    <span class="fs-14 fw-600 text-secondary">
                                        Priority
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <multiselect
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                            name="priority" v-model="priority" :disabled='!activateEditDeal'
                                            :options="priority_options" :searchable="true" :max-height="200"
                                            v-validate="'required'" placeholder="Select Priority"
                                            :class="{'cursor-event': selected_status != 'Active'}">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Priority Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mt-4">
                                    <span class="fs-14 fw-600 text-secondary">
                                        Deal Pipeline Name
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <multiselect :loading="pipeline_loading" disabled label="pipeline_name"
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                                v-validate="'required'" :searchable="true"
                                                :options="deals_pipeline_options" name="deal_pipeline"
                                                @search-change="searchPipelines"
                                                :class="{'cursor-event': selected_status != 'Active'}"
                                                v-model="deal_pipeline" placeholder="Select Deal Pipeline">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Deal Pipelines not
                                                        found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found
                                                    </div>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfPipelines" />
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <span class="invalid-feedback-form text-danger"
                                        v-show="errors.has('deal_pipeline_name')">
                                        {{errors.first('deal_pipeline_name')}}
                                    </span>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mt-4">
                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                        Expected Close Date
                                    </span>
                                    <div class="d-flex align-items-center mt-3">
                                        <date-picker v-model="expected_close_date" name="expected-close-date"
                                            :disabled='!activateEditDeal'
                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                            :class="{'cursor-event': selected_status != 'Active'}" format="YYYY-MM-DD"
                                            value-type="format" type="date" lang="en" :clearable="false"
                                            :editable="false" confirm confirm-text="APPLY">
                                        </date-picker>
                                    </div>
                                    <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('priority')">
                                    {{errors.first('priority')}}
                                </span> -->
                                </div>
                                <!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-4">
                                    <span class="fs-14 fw-600 px-2 text-secondary">
                                        Expected Revenue ({{transaction_symbol}})
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <input name="expected-revenue" :disabled='!activateEditDeal'
                                            :class="{'cursor-event': selected_status != 'Active'}"
                                            v-validate="'required||numeric'" class="inputFieldNew mt-3" type="text"
                                            v-model="expected_revenue" placeholder="Enter Expected Revenue" />
                                        <i class="icon icon-tick-warning icon-check-circle ml-2 mt-2"></i>
                                    </div>
                                    <span class="invalid-feedback-form text-danger"
                                        v-show="errors.has('expected-revenue')">
                                        {{errors.first('expected-revenue')}}
                                    </span>
                                </div>
                                <span class="invalid-feedback-form text-danger"
                                    v-show="errors.has('deal_pipeline_name')">
                                    {{errors.first('deal_pipeline_name')}}
                                </span> -->
                            </div>
                            <div class="row px-8">
                                <!-- <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mt-4">
                                    <span class="fs-14 fw-600 px-2 text-secondary">
                                        Forecast Category
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <multiselect
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3 text-capitalize"
                                                name="forecast_category" :searchable="true"
                                                :disabled='!activateEditDeal' v-model="forecast_category"
                                                :max-height="200" v-validate="'required'"
                                                :class="{'cursor-event': selected_status != 'Active'}"
                                                :options="forecast_category_options"
                                                placeholder="Select Forecast Category">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Forecast Categories
                                                        Not
                                                        Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <span class="invalid-feedback-form text-danger"
                                        v-show="errors.has('forecast_category')">
                                        {{errors.first('forecast_category')}}
                                    </span>
                                </div> -->
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4">
                                    <span class="fs-14 fw-600 text-secondary">
                                        Salesperson Name
                                    </span>
                                    <div class="d-flex">
                                        <multiselect
                                        class="diginew-multiselect salesperson-multiselect new-align-multi no-default-icon mt-2"
                                        style="cursor: no-drop;height: auto;background: #eff1f4 !important;"
                                        placeholder="Select Salesperson"  track-by="sales_person_id" disabled
                                        v-model="deal_details.sales_person_name_list" name="sales_person" label="name"
                                        :options="deal_details.sales_person_name_list"
                                        :multiple="true" :options-limit="300">
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag" style="padding-bottom: 8px;border-radius: 16px;cursor: no-drop;margin: 4px 4px 4px 0px;">
                                                <span class="filterSelectedName" style="cursor: no-drop;max-width: fit-content">{{ option.name }}</span>
                                                    <!-- <span class="custom__remove pointer">
                                                    <i class="icon icon-close fs-16 text-white"></i>
                                                    </span> -->
                                                </span>
                                            </template>
                                        </multiselect>
                                        <span class="mt-4">
                                            <span class="mt-1"><i class="icon icon-tick-success icon-check-circle ml-2 mt-2"></i></span>
                                        </span>
                                    </div>
                                    <!-- <div v-for="(salesperson, salesperson_index) in deal_details.sales_person_name_list" :key="salesperson_index" class="d-flex align-items-center">
                                        <input name="salesperson-name" v-validate="'required'" disabled
                                            class="inputFieldNew mt-3" type="text" v-model="salesperson.name"
                                            placeholder="Enter Salesperson Name " />
                                        <i class="icon icon-tick-success icon-check-circle ml-2 mt-2"></i>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('salesperson-name')">
                                        {{errors.first('salesperson-name')}}
                                    </span> -->
                                </div>
                            </div>
                        </div>
                        <!-- Deal Permission Section -->
                        <div class="create-company-header d-flex align-items-center justify-content-between text-flow mt-8">
                            <span class="fs-14  pl-3 text-white ml-3">Permissions</span>
                            <span class="pointer ml-auto" v-if="editDealPermissions && selected_status == 'Active'">
                                <i class="icon fs-16 mr-2 icon-pencil text-white " v-if="userPermissions.deals.permitted_actions.edit" @click="editPermissions()"></i>
                            </span>
                            <span v-if="!editDealPermissions && userPermissions.deals.permitted_actions.edit" class="ml-auto">
                                <button @click="saveDealsPermissions()" class="btn btn-new-save btn-wide px-2">Save</button>
                                <button @click="cancelDealPermissions()"
                                    class="btn btn-discard text-whte btn-wide ml-3 px-2">Discard</button>
                            </span>
                            <span class="pointer ml-2" @click="expandPermission()">
                                <i v-if="!showDealPermissions" class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="permissions_loading" class="mb-8 pb-8 text-right" style="position: relative;">
                            <hollow-dots-spinner style="position: absolute;left: 48%;margin: 0;top: 25px;" :animation-duration="1200" :dot-size="12" :dots-num="3" :color="'#00448b'" />
                        </div>
                        <div v-else-if="showDealPermissions">
                            <div class="row mt-3">
                                <div class="col-lg-12 col-md-12 col-sm-12 pl-8 pr-8">
                                    <div class="form-group pt-0">
                                        <div class="d-flex align-items-center my-3">
                                            <span class="text-secondary whiteSpace fs-14 fw-600 ml-3">Access To :</span>
                                            <div class="d-flex justify-content-between ml-4 align-items-center">
                                                <div class="form-check form-check-inline mb-1 ">
                                                    <label class="form-check-label check-label-dc">
                                                        <input class="form-check-input"
                                                            type="radio"
                                                            :disabled="selected_status != 'Active' || editDealPermissions == true"
                                                            value="private"
                                                            name="email_individual"
                                                            @change="changePermission('private')"
                                                            v-model="general_access" />
                                                        <span class="radio-icon"></span>
                                                    </label>
                                                </div>
                                                <span class="text-secondary fs-14 fw-600 mr-7">Individual and Team</span>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div
                                                    class="form-check form-check-inline mr-2 mb-1  ">
                                                    <label
                                                        class="form-check-label check-label-dc">
                                                        <input class="form-check-input"
                                                            type="radio"
                                                            :disabled="selected_status != 'Active' || editDealPermissions"
                                                            value="public"
                                                            name="email_all"
                                                            @change="changePermission('public')"
                                                            v-model="general_access" />
                                                        <span class="radio-icon"></span>
                                                    </label>
                                                </div>
                                                <span class="text-secondary fs-14 fw-600">All
                                                    <sup class="fs-14 mandatory">
                                                        <el-tooltip class="item" effect="dark"
                                                            content="Visible to everyone within company"
                                                            placement="bottom"
                                                            style="word-break: break-word;">
                                                            <i class="icon-information text-secondary pl-1"
                                                                style="font-size: 18px"></i>
                                                        </el-tooltip>
                                                    </sup>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center my-3" >
                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                <span class="text-secondary whiteSpace fs-14 fw-600">Individual</span>
                                                <multiselect class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                    :disabled="general_access == 'public' || editDealPermissions"
                                                    name="email_recipients"
                                                    @search-change="searchIndividuals"
                                                    @select="selectIndividual($event)"
                                                    @remove="customIndividualRemove($event)"
                                                    :loading="individual_loadig"
                                                    v-model="add_permission.individual"
                                                    :searchable="true" :block-keys="['Tab']"
                                                    placeholder="Add Members"
                                                    :options="individualMemberOptions"
                                                    :multiple="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                    :clear-on-select="true"
                                                    :hide-selected="true"
                                                    label="email"
                                                    track-by="email">
                                                    <template slot="tag"
                                                        slot-scope="{ option, remove }">
                                                        <span class="custom__tag" :class="{'pointer-events':general_access == 'public' || editDealPermissions}">
                                                            <span>{{ option.email }}</span>
                                                            <span class="custom__remove mt-1"
                                                                @click="remove(option)">
                                                                <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                            </span>
                                                        </span>
                                                    </template>
                                                    <template slot="afterList">
                                                        <div
                                                            v-observe-visibility="reachedEndOfIndividuals" />
                                                    </template>
                                                    <template slot="noOptions">
                                                        <div
                                                            class="text-secondary text-center fw-600">
                                                            List is Empty</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div
                                                            class="text-secondary text-center fw-600">
                                                            No Results Found</div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                <span class="text-secondary whiteSpace fs-14 fw-600">Team</span>
                                                <multiselect class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                    :disabled="general_access == 'public' || editDealPermissions"
                                                    name="email_recipients"
                                                    @search-change="searchTeam"
                                                    @select="selectTeam($event)"
                                                    @remove="customTeamRemove($event)"
                                                    :loading="team_loadig"
                                                    v-model="add_permission.team"
                                                    :searchable="true" :block-keys="['Tab']"
                                                    placeholder="Add Team"
                                                    :options="teamOptions"
                                                    :multiple="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                    :clear-on-select="true"
                                                    :hide-selected="true"
                                                    label="email_id"
                                                    track-by="email_id">
                                                    <template slot="tag"
                                                        slot-scope="{ option, remove }">
                                                        <span class="custom__tag" :class="{'pointer-events':general_access == 'public' || editDealPermissions}">
                                                            <span>{{ option.email_id }}</span>
                                                            <span class="custom__remove mt-1"
                                                                @click="remove(option)">
                                                                <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                            </span>
                                                        </span>
                                                    </template>
                                                    <template slot="afterList">
                                                        <div
                                                            v-observe-visibility="reachedEndOfTeam" />
                                                    </template>
                                                    <template slot="noOptions">
                                                        <div
                                                            class="text-secondary text-center fw-600">
                                                            List is Empty</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div
                                                            class="text-secondary text-center fw-600">
                                                            No Results Found</div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!editDealPermissions" class="col-lg-12 col-md-12 col-sm-12">
                                <div class="row">
                                    <div class="btn-align mt-2 w-100" style="justify-content:flex-end;">
                                        <button type="button" class="reset-btn mt-2 mr-8" style="box-shadow: none;" @click="resetPermissions()">
                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg" alt="" style="margin-right:2px;">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Additional Information Section -->
                        <div class="create-company-header d-flex align-items-center justify-content-between mt-6">
                            <span class="fs-14  pl-3 text-white ml-3">Additional Information</span>
                            <span class="pointer ml-auto" >
                                <i v-if="EditAddInfo && selected_status == 'Active' && userPermissions.deals.permitted_actions.edit"
                                    class="icon fs-16 mr-2 icon-pencil text-white " @click="hideEditAdd"></i>
                            </span>
                            <span
                                v-if="updateAddInfo && userPermissions.deals.permitted_actions.edit && selected_status == 'Active'">
                                <button @click="updateAdditionalInfo()"
                                    class="btn btn-new-save btn-wide px-2">Save</button>
                                <button @click="restoreData()"
                                    class="btn btn-discard text-whte btn-wide ml-3 px-2">Discard</button>
                            </span>
                            <span class="pointer ml-2" @click="showAddInfo">
                                <i v-if="!show_additional_info"
                                    class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <!-- <div v-if="show_additional_info && additional_info.length == 0 || check_visibility"
                            class="font-weight-bold mt-4 text-center">
                            No Data Found
                        </div> -->
                        <div class="row px-8 mb-6" v-if="show_additional_info && additional_info.length ">
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-5"
                                v-for="(info,additional_index) in additional_info" :key="additional_index"
                                v-show="info.visibility" :class="{'d-none':info.visibility == false}">
                                <div class="form-group contactGroup" v-if="info.field_type == 'input_field'">
                                    <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <span class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                          <input :disabled='!activateEdit' @input="updateData(additional_index)"
                                                class="input-field" style="margin-top:3px;" autocomplete="off"
                                                v-if="info.data_type == 'text'" :maxLength="info.character_limit"
                                                v-model="info.value" type="text"
                                                :placeholder="'Enter ' + info.field_name.replace('_',' ')" />
                                            <input :disabled='!activateEdit' @input="updateData(additional_index) "
                                                class="input-field" style="margin-top:3px;" autocomplete="off"
                                                v-else-if="info.data_type == 'decimal'" v-model.number="info.value"
                                                v-on:keypress="isNumber($event)" type="text"
                                                :placeholder="'Enter ' + info.field_name.replace('_',' ')" />
                                            <input :disabled='!activateEdit' @input="updateData(additional_index)"
                                                class="input-field" style="margin-top:3px;" autocomplete="off"
                                                v-else-if="info.data_type == 'integer'" v-model.number="info.value"
                                                type="number" :placeholder="'Enter ' + info.field_name.replace('_',' ')"
                                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' />
                                        </div>
                                    </div>
                                    <span class="highlightContact"></span>
                                    <span class="barContact"></span>
                                    <span class="pull-right text-right text-grey font-600 fs-12 pt-1"
                                        @change="updateData(additional_index)" v-if="info.data_type == 'Text'"
                                        :disabled='!activateEdit'>{{ info.limit - info.value.length}}/{{info.limit}}</span>
                                </div>
                                <div class="form-group" :disabled='!activateEdit'
                                    v-if="info.field_type == 'selection_field' && info.data_type == 'radio_button' && info.hasOwnProperty('options') ">
                                    <span class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                    <div class="mt-2">
                                        <el-radio-group v-model="info.value" @change="updateData(additional_index)"
                                            v-for="option in info.options" :key="option" class="w-200px">
                                            <el-radio class="ml-2 pt-2" :disabled='!activateEdit' :label="option.value"
                                                :id="option">{{option.value}}</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="pt-0" v-if="info.field_type=='input_field' && info.data_type=='date' ">
                                    <date-picker @change="updateData(additional_index)" :disabled='!activateEdit'
                                        class="cal-icon profile-date-picker date-input-customer  calendar-edit-per input-field pt-0 pb-0 pr-0"
                                        v-model="info.value" value-type="format" lang="en" type="date"
                                        format="YYYY-MM-DD"></date-picker>
                                </div>
                                <div class="form-group contactGroup" style="margin-top: 0px;"
                                    v-if="info.field_type == 'selection_field' && info.data_type == 'drop_down' ">
                                    <span
                                        class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                    <multiselect v-model="info.value" :disabled='!activateEdit'
                                        @select="updateData(additional_index)"
                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-1"
                                        id="ajaxnew" :placeholder="'Select ' + info.field_name.replace('_',' ')"
                                        :options="info.options" :multiple="false" :searchable="true" label="value"
                                        :internal-search="true" :clear-on-select="false" :close-on-select="true"
                                        :max-height="200" :show-no-results="true" :hide-selected="false"
                                        open-direction="top">
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Options Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <!-- modified -->
                        <div class="row px-8">
                            <!-- Notes Section -->
                            <div class="col-lg-4 col-md-12 col-sm-12 col-md-offset-2 mt-5 flex-width">
                                <div class="stage-sections">
                                    <div class="bg-blue pl-5">Notes</div>
                                    <div v-if="loadNotesSection == false" class="d-flex justify-content-end p-1">
                                        <button
                                            class="btn btn-secondary text-white deals-border-radius mt-3 btn-width mr-2"
                                            v-if="selected_status == 'Active'" @click="OpenNotesModal()">
                                            Add Notes
                                        </button>
                                    </div>
                                    <div v-else class="d-flex justify-content-end p-1">
                                        <button
                                            class="btn mt-3 btn-width mr-2" disabled style="position: relative;border-radius: 5px;">
                                            Add Notes
                                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                        </button>
                                    </div>
                                    <div class="pb-2 notes-div">
                                        <div class="d-flex align-items-center justify-content-center h-100"
                                            v-if="load_notes">
                                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                        <div class="text-center w-100 fw-600 mt-14" v-else-if="notes.length == 0">
                                           No Notes Found
                                        </div>
                                        <div v-else v-for="(note,index) in notes" :key="index"
                                            class="d-flex flex-column p-2 mt-2 mx-4 bordrad-5px"
                                            style="box-shadow: 0 0 6px 0 #939393;">
                                            <div class="d-flex justify-content-between">
                                                <div style="width:353px;">
                                                    <span class="fs-12 text-flow">{{note.notes}}</span>
                                                </div>
                                                <div class="d-flex" v-if="selected_status == 'Active'">
                                                    <i @click="openEditNotesModal(note)" v-if="userPermissions.deals.permitted_actions.edit"
                                                        class="icon icon-pencil pointer text-dark-blue"></i>
                                                    <i class="icon icon-trash pointer text-dark-blue ml-2"
                                                        @click="deleteNotes(index)"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Territory Section -->
                            <div class="col-lg-4 col-md-12 col-sm-12 mt-5 col-md-offset-2 flex-width">
                                <div class="stage-sections">
                                    <div class="bg-blue">Assign Territory</div>

                                    <div class="d-flex align-items-center justify-content-center mt-15"
                                        v-if="load_territories">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                            style="margin: 0 auto;" />
                                    </div>
                                    <div v-else>
                                        <div class="d-flex align-items-center justify-content-end px-2 pt-2">
                                            <div v-if="territory_data.length < 1"
                                                class="d-flex justify-content-end p-1">
                                                <button v-if="!territory && selected_status == 'Active'"
                                                    class="btn btn-secondary text-white deals-border-radius mt-3 btn-width m-0"
                                                    @click="territoryListData()">Add Territory</button>
                                            </div>
                                            <div v-else class="d-flex align-items-center ml-2 mt-2">
                                                <button @click="saveTerritory" :disabled="!territory_selected"
                                                    class="btn btn-success text-white btn-sm"
                                                    style="border-radius:5px !important;">Save</button>
                                                <span class="pointer" @click="goToSettings">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                        placement="bottom">
                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                            class="ml-2" style="width:20px" alt="">
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="inner-content-overflow">
                                            <div v-if="territory_data.length > 0">
                                                <div class="territory-content"
                                                    v-for="(territory,index) in territory_data" :key="index">
                                                    <h3 class="fs-14 fw-600"
                                                        @click="getSubTerritoryDetails(index, territory.id)">
                                                        <i class="icon pointer text-dark-blue fs-14"
                                                            :class="{'icon-plus-circle':!territory.show_territory, 'icon-minus-circle':territory.show_territory}"
                                                            data-toggle="collapse" :href="'#territory'+index"
                                                            role="button" aria-expanded="false"
                                                            aria-controls="collapseExample"></i>
                                                        <span class="pointer"
                                                            @click="selectTerritory(index, 'add_index', 'list_index', territory.id, 'territory')"
                                                            :class="{'territory-selected':territory.selected}">{{territory.name}}</span>
                                                    </h3>
                                                    <ul class="collapse" :id="'territory'+index">
                                                        <li v-for="(add,add_index) in territory.sub_territories"
                                                            :key="add_index">
                                                            <h3 class="fs-14 fw-600"
                                                                @click="getSubSubTerritoryDetails(index, add_index)">
                                                                <i class="icon pointer text-dark-blue fs-14"
                                                                    :class="{'icon-plus-circle':!add.show_sub_territory, 'icon-minus-circle':add.show_sub_territory}"
                                                                    data-toggle="collapse"
                                                                    :href="'#hierarchy'+add_index+''+index"
                                                                    role="button" aria-expanded="false"
                                                                    aria-controls="collapseExample"></i>
                                                                <span class="pointer"
                                                                    @click="selectTerritory(index, add_index, 'list_index', add.id, 'sub_territory')"
                                                                    :class="{'territory-selected':add.selected}">{{add.name}}</span>
                                                            </h3>
                                                            <ul class="collapse" :id="'hierarchy'+add_index+''+index">
                                                                <li v-for="(list,list_index) in add.sub_territories"
                                                                    :key="list_index">
                                                                    <h3 class="fs-14 fw-600">
                                                                        <span
                                                                            @click="selectTerritory(index, add_index, list_index, list.id, 'sub_sub_territory')"
                                                                            class="pointer"
                                                                            :class="{'territory-selected':list.selected}">{{list.name}}</span>
                                                                    </h3>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-if="territory">
                                                    <div
                                                        class="d-flex align-items-center justify-content-end ml-2 mr-2">
                                                        <div class="d-flex justify-content-end p-1" >
                                                            <i @click="territoryListData()"
                                                                v-if="selected_status == 'Active' && userPermissions.deals.permitted_actions.edit"
                                                                class="icon icon-pencil text-secondary pointer fs-16"></i>
                                                        </div>
                                                        <span class="pointer" @click="goToSettings">
                                                            <el-tooltip class="item" effect="dark"
                                                                content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                                placement="bottom">
                                                                <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                                    class="ml-2" style="width:20px" alt="">
                                                            </el-tooltip>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex justify-content-between p-4">
                                                        <div class="p-2 d-flex flex-column"
                                                            style="max-height:285px;overflow:auto;width:100%">
                                                            <h3 class="fs-14 fw-600">
                                                                <i :class="toggle_territory_country_dropdown == true ? 'icon-minus-circle': 'icon-plus-circle'"
                                                                    class="icon mr-2 text-dark-blue pointer"
                                                                    @click="toggle_territory_dropdown('country')"
                                                                    data-toggle="collapse" href="#country" role="button"
                                                                    aria-expanded="false"
                                                                    aria-controls="collapseExample"></i>
                                                                {{territory.name}}
                                                            </h3>
                                                            <ul v-if="territory.sub_territory" class="collapse"
                                                                id="country">
                                                                <li>
                                                                    <h3 v-if="territory.sub_territory"
                                                                        class="fs-14 fw-600">
                                                                        <i :class="toggle_territory_state_dropdown == true ? 'icon-minus-circle': 'icon-plus-circle'"
                                                                            class="icon mr-2 pointer text-dark-blue"
                                                                            @click="toggle_territory_dropdown('state')"
                                                                            data-toggle="collapse" href="#state"
                                                                            role="button" aria-expanded="false"
                                                                            aria-controls="collapseExample"></i>
                                                                        {{territory.sub_territory.name}}
                                                                    </h3>
                                                                    <ul v-if="territory.sub_territory.sub_territory"
                                                                        class="collapse" id="state">
                                                                        <li>
                                                                            <h3 v-if="territory.sub_territory.sub_territory"
                                                                                class="fs-14 pl-4 fw-600">
                                                                                {{territory.sub_territory.sub_territory.name}}
                                                                            </h3>
                                                                        </li>
                                                                    </ul>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="territory_data.length < 1"
                                                    class="fw-600 fs-14 mt-12 text-center">
                                                    No Territory Found
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Products Section -->
                            <div class="col-lg-4 col-md-12 col-sm-12 mt-5 col-md-offset-2 flex-width">
                                <div class="stage-sections">
                                    <div class="bg-blue pl-5">Products</div>
                                    <div>
                                        <div v-if="loadAddProducts == false" class="d-flex justify-content-end p-1">
                                            <button :disabled="deal_details.from_lead == true"
                                                class="btn btn-secondary text-white btn-width deals-border-radius mt-3"
                                                v-if="selected_status == 'Active'" @click="OpenAddProductModal()">Add
                                                New Products</button>
                                        </div>
                                        <div v-else class="d-flex justify-content-end p-1">
                                            <button
                                                class="btn btn-width mt-3"
                                               style="position: relative; border-radius: 5px;" disabled>Add
                                                <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                            </button>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center mt-15"
                                            v-if="load_products">
                                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                        <div v-else class="p-5 row" style="max-height: 219px;min-height: 219px;overflow:auto;">
                                            <div v-for="(product,index) in products" :key="index"
                                                class="p-2 mt-2 mx-2 bordrad-5px position-relative"
                                                style="box-shadow: 0 0 6px 0 #939393;width: 360px !important;">
                                                <div class="position-absolute mt-2 mr-2" style="right: 0;"
                                                    v-if="selected_status == 'Active'">
                                                    <i v-if="userPermissions.deals.permitted_actions.edit && deal_details.from_lead == true"
                                                        class="icon icon-pencil fs-16" style="cursor: no-drop;"></i>
                                                    <i @click="openEditProductModal(product)" v-if="userPermissions.deals.permitted_actions.edit && deal_details.from_lead == false"
                                                        class="icon icon-pencil pointer text-dark-blue fs-16"></i>
                                                    <i v-if="deal_details.from_lead == true" class="icon icon-trash ml-1 fs-16" style="cursor: no-drop;"></i>
                                                    <i v-if="deal_details.from_lead == false" class="icon icon-trash ml-1 pointer text-dark-blue fs-16" @click="deleteProduct(index)"></i>
                                                </div>
                                                <div class="d-flex">
                                                    <div class="pl-5 pr-5 pt-11">
                                                        <img src="/static/images/images-new-theme/icons/scm-product-image.png"
                                                            style="width:40px" alt="">
                                                    </div>
                                                    <div class="d-flex flex-column pt-2 pb-2 justify-content-center">
                                                        <h5 class="fs-14 fw-500 text-flow w-75">{{product.product_name}}
                                                            <span class="">
                                                                <el-popover
                                                                    placement="bottom"
                                                                    trigger="hover">
                                                                    <div class="fs-14 fw-600">
                                                                        {{product.product_name}} Info:
                                                                    </div>
                                                                    <div class="fs-12 fw-400 pt-1" v-for="(template, template_index) in product.template_details.fields" :key="template_index">
                                                                        <div class="fs-12 fw-400" style="padding-top: 2px !important;"><span style="width: 120px;">{{template.field_name}}</span>: 
                                                                            <span v-if="template.field_type == 'checkbox'" style="padding-left: 11px;"><span v-for="(value, value_index) in template.value" :key="value_index">{{value}}&nbsp;</span></span>
                                                                            <span v-else-if="template.field_type == 'date_and_time'" style="padding-left: 11px;"><span> {{template.date_value}} {{template.time_value}}</span></span>
                                                                            <span v-else style="padding-left: 11px;">{{template.value}} </span>
                                                                        </div>
                                                                    </div>
                                                                    <el-button slot="reference" class="text-secondary fw-500 fs-14" style="margin-top: -4px;">
                                                                        <i class="icon-information text-secondary"
                                                                        style="font-size: 20px;"></i>
                                                                    </el-button>
                                                                </el-popover>
                                                            </span>
                                                        </h5>
                                                        <h5 class="fs-14 fw-500">Quantity: {{product.quantity}}</h5>
                                                        <h5 class="fs-14 fw-500">Transaction Value Per Unit
                                                            ({{transaction_symbol}}) :
                                                            {{product.transaction_value_per_unit}}</h5>
                                                        <h5 class="fs-14 fw-500">Transaction Value
                                                            ({{transaction_symbol}}) : {{product.transaction_value}}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="!load_products"
                                        class="p-2 w-100 d-flex justify-content-between bordradblr-5px"
                                        style="background-color: #00448b;">
                                        <span class="fs-12 fw-600 text-white ml-3">Total ({{transaction_symbol}})</span>
                                        <span class="fs-12 fw-600 text-white mr-3">{{total_transaction}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Attachments Section -->
                        <div class="row mt-3 px-8">
                            <div class="col-lg-8 col-md-12 col-sm-12 mt-5 col-md-offset-2 flex-width">
                                <div class="stage-sections">
                                    <div class="bg-blue">Attachments</div>
                                    <div class="d-flex align-items-center justify-content-center" v-if="isUploadingInProgress == true" style="height: 300px;">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <div v-else-if="attachments.length < 1 && selected_status == 'Closed'"
                                        class="fw-600 fs-14 mt-12 text-center">
                                        No Attachments Added
                                    </div>
                                    <div v-else class="overflow-auto mx-ht">
                                        <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 pt-15"
                                            style="height: 18em; background: #f5f5f5; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;">
                                            <div class="px-12 mt-7 drag-drop-white-bg pt-2 pb-2 ml-4 mr-4"
                                                style="border: 5px dotted #e0e0e0">
                                                <p class="text-center fs-14 mb-0">
                                                    <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                                    Drag and drop your files here or
                                                    <file-upload class="choose-file btn fw-500 pl-0 pr-0 pointer"
                                                        :multiple="true"
                                                        :class="{'select-cursor': attachments.length >= 10 || selected_status != 'Active'}"
                                                        :drop="true" :drop-directory="true"
                                                        accept=".jpg, .png, .pdf, .docx, .txt, .gif, .jpeg, .xls, .xlsx, .csv, .eml"
                                                        @input-file="uploadAttachment" ref="upload"
                                                        style="text-transform: none !important; color: #0475f3;width: 8em;cursor: pointer !important;">
                                                        Browse
                                                    </file-upload>
                                                </p>

                                            </div>
                                            <div class="pt-4 pb-4">
                                                <p class="drag_drop_cond text-center fs-14">
                                                    Supports .jpg,.png,.pdf,.docx,.txt,.gif,.jpeg,.xls,.xlsx,.csv,.eml
                                                    <br>
                                                    Size limit- 25.00 MB (Max 10 files)
                                                </p>
                                            </div>
                                        </div>
                                        <div class="p-4" v-for="(attachment,index) in attachments"
                                            :key="attachment.url">
                                            <span  class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                                <img v-if="attachment.url.endsWith('.pdf')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                <img v-else-if="attachment.url.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                <img v-else-if="attachment.url.endsWith('.xls') || attachment.name.endsWith('.xlsx')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                <img v-else-if="attachment.url.endsWith('.doc') || attachment.name.endsWith('.docx')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                <img v-else :src="attachment.url" alt="">

                                                <!-- <img class="icon-img" v-if="attachment.url.endsWith('.jpg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                <img class="icon-img" v-else-if="attachment.url.endsWith('.pdf')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.url.endsWith('.png')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.url.endsWith('.docx')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.url.endsWith('.txt')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.url.endsWith('.gif')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.url.endsWith('.jpeg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.url.endsWith('.xlsx')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.url.endsWith('.xls')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" /> -->
                                            </span>
                                            <!-- <span class="_images pointer" style="position: relative;"
                                                @click="previewImage(attachment)">
                                                <img :src="attachment.url" alt="">
                                            </span> -->
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <img class="icon-img" v-if="attachment.name.endsWith('.jpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                        <img class="icon-img" v-if="attachment.name.endsWith('.pdf')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                                        <img class="icon-img" v-else-if="attachment.name.endsWith('.png')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                        <img class="icon-img" v-else-if="attachment.name.endsWith('.docx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                                        <img class="icon-img" v-else-if="attachment.name.endsWith('.txt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                                        <img class="icon-img" v-else-if="attachment.name.endsWith('.gif')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                        <img class="icon-img" v-else-if="attachment.name.endsWith('.jpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                        <img class="icon-img" v-else-if="attachment.name.endsWith('.xlsx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                                        <img class="icon-img" v-else-if="attachment.name.endsWith('.xls')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                                    </div>
                                                    <div class="col">
                                                        <div class="d-flex justify-content-between">
                                                            <el-tooltip :content="attachment.name" placement="top">
                                                                <div
                                                                    class="font-weight-bold text-truncate d-block mx-width-220">
                                                                    {{attachment.name}}</div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-if="attachment.uploading || attachment.url == undefined">
                                                            <progress-bar class="progressBar w-100"
                                                                :class="{'error-upload':attachment.url == undefined}"
                                                                :val="attachment.progress" size="small"></progress-bar>
                                                        </div>
                                                        <div class="d-flex justify-content-between">
                                                            <div class="text-danger pl-0 fw-500"
                                                                v-if="attachment.error != ''">{{attachment.error}}...
                                                            </div>
                                                            <div class="text-secondary fw-500"
                                                                v-if="attachment.progress<100 && attachment.error == ''">
                                                                {{attachment.progress}}% Uploaded</div>
                                                            <div class="fw-500">({{attachment.size | prettyBytes}})
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined"
                                                    class="pointer" @click="deleteAttachment(index)">
                                                    <i class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>
                                                <div v-else class="pointer" @click="deleteAttachment(index)">
                                                    <i class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Action Log Section -->
                            <div class="col-lg-4 col-md-12 col-sm-12 mt-5 col-md-offset-2 flex-width">
                                <div class="stage-sections">
                                    <div class="bg-blue">Action Log</div>
                                    <div class="overflow-auto mx-ht">
                                        <table class="table-properties text-center">
                                            <thead>
                                                <tr style="text-align: left !important;">
                                                    <th>Action</th>
                                                    <th>Date and Time</th>
                                                    <th>User Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(act, i) in ActionLogs" :key="i" style="text-align: left !important;">
                                                    <td>{{act.action}}</td>
                                                    <td>{{act.changed_time}}</td>
                                                    <td>{{act.changed_by_name}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <add-product @hide-add-product="hideAddProductModal" :added_products="saved_products" @saveProduct="saveProduct"
            @saveEditProduct="saveEditProduct" :product_type="product_type" :product_data="product_data"
            v-if="add_product" modal_name="Add-Product"></add-product>
        <add-notes v-if="add_notes" @saveNotes="saveNotes" @saveEditNotes="saveEditNotes" :note_type="note_type"
            :note_data="note_data" @hide-notes-modal="hideNotes" modal_name="Add-Notes"></add-notes>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
        <deal-delete @hidePopup="hidePopup" v-if="delete_disabled" modal_name="OneReminder"></deal-delete>
    </div>
</template>

<script>
    const AddProduct = () => import('./AddProduct')
    const AddNotes = () => import('./AddNotes')
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import pipeline_lazy_loading from "../mixins/pipeline_lazyloading";
    import deals from "../mixins/deals";
    import callreport from '../mixins/callreport';
    import teams from '../mixins/teams';
    const Preview = () => import('../Preview');
    var mime = require('mime-types');
    import {
        EventBus
    } from '../eventBus/nav-bar-event';
    import territory_lazy_loading from "../mixins/territory_lazy_loading";
    import axios from "axios";
    import products from "../mixins/products.js";
    import convert from "../mixins/convert.js";
    import settings from "../mixins/settings.js";
    import globals from "../globals";
    import { debounce } from 'lodash'
    import { HollowDotsSpinner } from "epic-spinners";
    import DealDelete from "./OneDealDeletePopup"
    export default ({
        data() {
            return {
                loadAddProducts: false,
                loadNotesSection: false,
                success_msg: "",
                warning_msg: "",
                ajaxCallInProgress: false,
                owner_name: '',
                salesperson_name: '',
                contact_name: '',
                customer_name: '',
                priority: '',
                priority_options: ['High','Low','Medium'],
                deal_pipeline: null,
                deals_pipeline_options: [],
                expected_revenue: 432987,
                forecast_category: '',
                forecast_category_options: ['Best Case', 'Commit', 'Pipeline'],
                expected_close_date: '',
                toggle_territory_country_dropdown: false,
                toggle_territory_state_dropdown: false,
                toggle_territory_city_dropdown: false,
                add_product: false,
                add_notes: false,
                temp_deal_data: null,
                territory: null,
                products: [],
                ActionLogs: [],
                selected_status: null,
                deal_details: null,
                //notes
                notes_loading: false,
                temp_notes: [],
                notes_count: 0,
                notes_scrollable: false,
                notes_visible: false,
                notes: [],
                temp_products: [],
                temp_attachments: [],
                note_type: '',
                note_data: {},
                product_type: '',
                selected_lead_id: {},
                transaction_symbol: '$',
                territory_data: [],
                sub_territories: null,
                sub_territories_loading: false,
                deal_territory_id: '',
                add_edit_territory: true,
                territory_selected: false,
                load_products: false,
                preview_file: '',
                preview_visible: false,
                isUploadingInProgress: false,
                attachment_file: "",
                check_attachments: false,
                attachments: [],
                show_additional_info: true,
                show_Deal_info: true,
                products: [{
                    product_id: "",
                    quantity: null,
                    product_name: null,
                    transition_value_perunit: 0,
                    transition_value: 0
                }],
                products_count: 0,
                products_loading: false,
                products_scrollable: false,
                products_visible: false,
                temp_products: [],
                products_options: [],
                load_notes: false,
                load_territories: false,
                additional_info: [],
                deal_info: [],
                selected_index: null,
                activateEdit: false,
                activateEditDeal: false,
                check_visibility: false,
                EditDealInfo: true,
                EditAddInfo: true,
                updateAddInfo: false,
                updateDeal: false,
                temp_add_info: [],
                total_file_size: 0,
                add_permission:{
                    individual:[],
                    team:[]
                },
                permissions:{
                    individual_permission_list:[],
                    team_permission_list:[]
                },
                editDealPermissions: true,
                showDealPermissions: true,
                general_access:"private",
                user_ids_ind: [],
                individualMemberOptions: [],
                individual_visible: false,
                temp_individual_member_options: 0,
                individual_loadig: false,
                individual_scrollable: false,
                individual_count: 0,
                user_ids_team:[],
                teamOptions: [],
                team_visible: false,
                temp_team_options: 0,
                team_loadig: false,
                team_scrollable: false,
                permissions_loading: false,
                team_count: 0,
                delete_disabled: false,
                saved_products: [],
                product_data: []
            }
        },
        mixins: [pipeline_lazy_loading, deals, territory_lazy_loading, products, convert, settings, callreport, teams],
        components: {
            HalfCircleSpinner,
            AddProduct,
            AddNotes,
            SweetModal,
            Preview,
            HollowDotsSpinner,
            DealDelete
        },
        methods: {
            hideDeleteType(){
                this.delete_disabled = false
            },
            viewPipeline(){
                //this.$router.push("/deals/viewdeals/list")
                localStorage.setItem("deal_pipeline_view",JSON.stringify(this.deal_details));
                localStorage.setItem("deal_id",this.$route.params.id);
                this.$router.push(`/deals/viewdeals/viewpipeline`)
            },
            customIndividualRemove(data){
                this.permissions.individual_permission_list.forEach((el,del_individual_index) => {
                    if(el.id == data.id){
                        this.permissions.individual_permission_list.splice(del_individual_index,1)
                    } else if(el.id == data.user_id){
                        this.permissions.individual_permission_list.splice(del_individual_index,1)
                    }
                })
            },
            customTeamRemove(data){
                this.permissions.team_permission_list.forEach((el,del_team_index) => {
                    if(data.id == el.id){
                        this.permissions.team_permission_list.splice(del_team_index,1)
                    }
                })
            },
            resetPermissions(){
                this.add_permission.individual = [];
                this.add_permission.team = [];
                this.permissions.individual_permission_list = [],
                this.permissions.team_permission_list = []
            },
            editPermissions(){
                this.editDealPermissions = false;
            },
            // API call to save Deal Permission
            async saveDealsPermissions(){
                this.editDealPermissions = true;
                this.permissions_loading = true;
                let response = await this.editDeals(this.$route.params.id, this.update_deal)
                this.success_msg = "Deal Permission Updated Successfully"
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadDealDetails();
                }, 2000);
                setTimeout(() => {
                    this.permissions_loading = false;
                }, 4000);
            },
            cancelDealPermissions(){
                this.editDealPermissions = true;
                this.permissions_loading = true;
                this.loadDealDetails();
            },
            expandPermission(){
                if (!this.showDealPermissions) {
                    this.showDealPermissions = true;
                } else {
                    this.showDealPermissions = false;
                }
            },
            changePermission(selected_type) {
                if(selected_type == 'public'){
                    this.add_permission.individual = []
                    this.add_permission.team = [],
                    this.permissions.individual_permission_list = [],
                    this.permissions.team_permission_list = []
                }
            },
            selectIndividual(data){
                this.permissions.individual_permission_list.push({
                    email_id: data.email,
                    id: data.user_id,
                    name: data.full_name
                })
            },
            selectTeam(data){
                this.permissions.team_permission_list.push({
                    email_id: data.email_id,
                    id: data.id,
                    name: data.name
                })
            },
            async searchIndividualsDebounce(key) {
                try{
                    let params = {
                        limit: 10,
                        skip: 0,
                        search_key: key,
                        exclude: this.user_ids_ind
                    };
                    let response = await this.getMembersData(params)
                    this.individualMemberOptions = response.response
                    this.individual_count = this.temp_individual_member_options
                    this.individual_scrollable = false
                }
                catch(reason){
                }
            },
            async reachedEndOfIndividuals(reached){
                this.individual_visible = reached
                if (reached) {
                    if (this.individual_scrollable == false) {
                        this.individual_loadig = true
                        let params ={
                            skip:this.individual_count,
                            limit:10,
                            search_key:"",
                            exclude: this.user_ids_ind
                        }
                        let response = await this.getMembersData(params)
                        this.temp_individual_member_options = response.response.length;
                        if (response.skip == this.individual_count) {
                            if (this.temp_individual_member_options > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.individualMemberOptions.push(el);
                                });
                                this.individual_count += response.response.length;
                                this.individual_loadig = false
                            } else {
                                this.individual_scrollable = true
                                this.individual_loadig = false
                            }
                        }
                        this.individual_loadig = false
                    }
                }
            },
            async searchTeamDeounce(key) {
                try{
                    let params = {
                        limit: 10,
                        skip: 0,
                        search_key: key,
                        filter_json:{
                            exclude: this.user_ids_team
                        }
                    };
                    let response = await this.getPermissionList(params)
                    this.teamOptions = response.response
                    this.team_count = this.temp_team_options
                    this.team_scrollable = false
                }
                catch(reason){
                }
            },
            async reachedEndOfTeam(reached){
                this.team_visible = reached
                if (reached) {
                    if (this.team_scrollable == false) {
                        this.team_loadig = true
                        let params ={
                            skip:this.team_count,
                            limit:10,
                            search_key:"",
                            filter_json:{
                                exclude: this.user_ids_team
                            }
                        }
                        let response = await this.getPermissionList(params)
                        this.temp_team_options = response.response.length;
                        if (response.skip == this.team_count) {
                            if (this.temp_team_options > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.teamOptions.push(el);
                                });
                                this.team_count += response.response.length;
                                this.team_loadig = false
                            } else {
                                this.team_scrollable = true
                                this.team_loadig = false
                            }
                        }
                        this.team_loadig = false
                    }
                }
            },
            //hide the edit icon
            hideEdit() {
                this.activateEditDeal = true;
                this.updateDeal = true
                this.EditDealInfo = false
            },
            //hide the add icon
            hideEditAdd() {
                this.activateEdit = true;
                this.updateAddInfo = true
                this.EditAddInfo = false
            },
            //update deals data
            /**@params = index */
            updateData(index) {
                this.$forceUpdate()
            },
            //restore data of the additional info
            /**@params - index */
            async restoreData(index) {
                this.loadAdditionalInfo()
                this.activateEdit = false;
                this.updateAddInfo = false
                this.EditAddInfo = true
                this.$forceUpdate()
            },
            //valdiation to check the number type data
            isNumber: function (evt, index) {
                evt = evt ? evt : window.event
                var charCode = evt.which ? evt.which : evt.keyCode
                if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                    evt.preventDefault()
                } else {
                    return true
                }
            },
            //Api call to udpate additional info data
            async updateAdditionalInfo() {
                this.$forceUpdate()
                let temp_additional_fields = []
                if (this.additional_info.length) {
                    this.additional_info.forEach(x => {
                        if (x.value) {
                            temp_additional_fields.push({
                                id: x._id,
                                key: x.field_name,
                                value: typeof x.value === 'object' ? x.value.value : x.value
                            })
                        }
                    })
                    this.update_deal['additional_info'] = temp_additional_fields
                    let response = await this.editDeals(this.$route.params.id, this.update_deal)
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.activateEdit = false;
                        this.updateAddInfo = false
                        this.EditAddInfo = true
                        this.loadAdditionalInfo();
                    }, 3000);
                }
            },
            //Redirect to the deals list view
            rediectList() {
                this.$router.push("/deals/viewdeals/list")
            },
            //API call to search products
            /**@params = item */
            async searchProducts(item) {
                this.products_loading = true
                /**@params = search_key*/
                let params = {
                    search_key: item,
                }
                let response = await this.ListProducts(params)
                this.products_options = response.response
                this.products_count = this.products_options.length
                this.products_loading = false
                this.products_scrollable = false
                this.products_options.forEach(x => {
                    x['product_name'] = x.name
                    x['product_id'] = x.id
                    x['transition_value'] = 0
                })
            },
            //Lazy loading of the products
            /**@params = reached */
            async reachedEndOfProducts(reached) {
                this.products_visible = reached
                if (reached) {
                    if (this.products_scrollable == false) {
                        this.products_loading = true
                        let response = await this.ListProducts({
                            skip: this.products_count,
                            limit: 10
                        })
                        this.temp_products = response.response.length;
                        if (response.skip == this.products_count) {
                            if (this.temp_products > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.products_options.push(el);
                                });
                                this.products_options = this.products_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.products_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });

                                this.products_options.forEach(x => {
                                    x['product_name'] = x.name
                                    x['product_id'] = x.id
                                    x['transition_value'] = 0
                                })

                                this.products_count += response.response.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                        }
                        this.products_loading = false
                    }
                }
            },
            //Show/hide Add Info data
            showAddInfo() {
                this.show_additional_info = !this.show_additional_info
            },
            //Show/hide Deal Info data
            showDealInfo() {
                this.show_Deal_info = !this.show_Deal_info
            },
            //Move the deals to archive
            async moveToArchive() {
                /**@params = id */
                let params = {
                    id: [this.$route.params.id]
                }
                let response = await this.moveDeals('archive', params)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadDealDetails();
                }, 3000);
            },
            //Move the deal to the active
            async moveToActive() {
                let params = {
                    id: [this.$route.params.id]
                }
                let response = await this.moveDeals('active', params)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadDealDetails();
                }, 3000);
            },
            //Save the product
            /**@params = value */
            async saveProduct(value) {
                this.products.push(value)
                this.temp_products = this.products;
                // this.products.forEach((x, i) => {
                //     if (x.id == this.products[index].id) {
                //         x.deal_id = thius.deal_id;
                //     } else {
                //         delete x['deal_id']
                //     }
                // })
                //delete the temp products data
                this.temp_products.forEach(x => {
                    // delete x['product_name']
                    delete x['deal_id']
                    delete x['is_delete']
                })
                let response = await this.editDeals(this.$route.params.id, this.update_deal)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.hideAddProductModal()
                    this.loadProducts();
                    this.product_data = []

                }, 3000);
            },
            //show the preview of the image
            /**@params = file */
            previewImage(file) {
                let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
                file['content_type'] = content_type;
                this.preview_file = file;
                this.preview_visible = true;
            },
            //hide the preview
            hidePreview() {
                this.preview_visible = false
            },
            //Redirect to the settings
            goToSettings() {
                let routeData = this.$router.resolve({
                    name: 'Settings',
                    query: {
                        territory_settings: true
                    }
                });
                window.open(routeData.href, '_blank');
            },
            //API call to save/edit the product
            /**@params = value */
            async saveEditProduct(value) {
                let index = this.products.findIndex(x => x.product_id == value.product_id)
                this.products[index] = value
                this.temp_products = this.products
                this.temp_products.forEach(x => {
                    // delete x['product_name']
                    delete x['deal_id']
                    delete x['is_delete']
                })
                let response = await this.editDeals(this.$route.params.id, this.update_deal)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.hideAddProductModal()
                    this.product_data = []
                    this.$refs.success_modal.close();
                    this.loadProducts();
                }, 3000);
            },
            //API call to save the deals
            async saveDeals() {
                setTimeout(async () => {
                    let response = await this.editDeals(this.$route.params.id, this.update_deal)
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.updateDeal = false
                        this.EditDealInfo = true
                        this.activateEditDeal = false
                        this.$forceUpdate()
                    }, 3000);
                }, 500);
            },
            //cancel the deals and reset the status
            cancelDeals() {
                this.forecast_category = this.temp_deal_data.forecast_category,
                    this.expected_revenue = this.temp_deal_data.expected_revenue,
                    this.expected_close_date = this.temp_deal_data.expected_close_date,
                    this.priority = this.temp_deal_data.priority,
                    this.activateEditDeal = false
                this.updateDeal = false
                this.EditDealInfo = true
            },
            //Update the territory list of data
            async territoryListData() {
                this.load_territories = true
                /**@params = skip, @params =limit */
                try {
                    let params = {
                        skip: 0,
                        limit: 10
                    };
                    let response = await this.getTerritoryList(params);
                    this.territory_selected = false;
                    this.territory_data = response.response;
                    this.territory_data.forEach(x => {
                        x['show_territory'] = false
                        x['edit_territory'] = false
                    })
                    this.load_territories = false
                } catch (error) {
                    this.load_territories = false
                }
            },
            //Get the sub territory details
            /**@params = index, @params = id */
            async getSubTerritoryDetails(index, id) {
                this.sub_territories_loading = true;
                try {
                    let response = await this.getTerritoryDetails(id);
                    this.sub_territories = response.response;
                    this.territory_data[index]['sub_territories'] = this.sub_territories.sub_territories;
                    this.territory_data[index]['sub_territories'].show_sub_territory = false;
                    this.territory_data[index]['sub_territories'].forEach(x => {
                        x['sub_territories']['show_sub_sub_territory'] = false
                    })
                    this.territory_data[index].show_territory = !this.territory_data[index].show_territory;
                    this.sub_territories_loading = false;
                    this.$forceUpdate();
                } catch (error) {
                }
            },
            //Get the sub sub territory details
            /**@params = index, @params = sub_index */
            getSubSubTerritoryDetails(index, sub_index) {
                this.territory_data[index].sub_territories[sub_index].show_sub_territory = !this.territory_data[
                    index].sub_territories[sub_index].show_sub_territory;
                this.$forceUpdate();
            },
            //select the terriotry
            /**@params = index, @params = sub_index, @params = sub_sub_index , @params =type */
            selectTerritory(index, sub_index, sub_sub_index, id, type) {
                this.deal_territory_id = id;
                this.territory_data.forEach(x => {
                    x.selected = false;
                    this.territory_selected = false;
                    if (x.hasOwnProperty('sub_territories')) {
                        x.sub_territories.forEach(y => {
                            y.selected = false;
                            this.territory_selected = false;
                            if (y.hasOwnProperty('sub_territories')) {
                                y.sub_territories.forEach(z => {
                                    z.selected = false;
                                    this.territory_selected = false;
                                })
                            }
                        })
                    }
                })
                //setting it's true/false based on the type of terriotry
                if (type == 'territory') {
                    this.territory_data[index].selected = true;
                    this.territory_selected = true;
                } else if (type == 'sub_territory') {
                    this.territory_data[index].sub_territories[sub_index].selected = true;
                    this.territory_selected = true;
                } else if (type == 'sub_sub_territory') {
                    this.territory_data[index].sub_territories[sub_index].sub_territories[sub_sub_index].selected =
                        true;
                    this.territory_selected = true;
                }
                this.$forceUpdate();
            },
            //API call to save/update the territory
            async saveTerritory() {
                let response = await this.editDeals(this.$route.params.id, {
                    deal_territory_id: this.deal_territory_id
                })
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                }, 3000);
                this.territory_data = [];
                //this.loadDealDetails();
                this.territoryListData();
            },
            toggle_territory_dropdown(obj) {
                if (obj == 'country') {
                    this.toggle_territory_country_dropdown = !this.toggle_territory_country_dropdown
                }
                if (obj == 'state') {
                    this.toggle_territory_state_dropdown = !this.toggle_territory_state_dropdown
                }
            },
            //Show the Add Product Modal
            OpenAddProductModal() {
                this.loadAddProducts = true;
                this.add_product = true
                this.product_type = 'add'
                this.product_data =  [];
                this.$forceUpdate()
                setTimeout(() => {
                    this.loadAddProducts = false;
                    this.$modal.show('Add-Product')
                }, 1000);
            },
            //Show the Edit Product Modal
            /**@parmas = data */
            openEditProductModal(data) {
                this.add_product = true
                this.product_type = 'edit'
                this.product_data = data;
                setTimeout(() => {
                    this.$modal.show('Add-Product')
                }, 1000);
            },
            //Hide the add product modal
            hideAddProductModal() {
                this.add_product = false
                this.product_data = [];
            },
            //Show the Add Notes Modal
            OpenNotesModal() {
                this.loadNotesSection = true;
                this.add_notes = true
                this.note_type = 'add'
                setTimeout(() => {
                    this.$modal.show('Add-Notes')
                    this.loadNotesSection = false;
                }, 500);
            },
            //Open the Edit Notes Modal
            /**@params = desc */
            openEditNotesModal(desc) {
                this.add_notes = true;
                this.note_type = 'edit';
                this.note_data = {
                    desc: desc.notes,
                    id: desc.id
                };
                setTimeout(() => {
                    this.$modal.show('Add-Notes')
                }, 500);
            },
            //hide the notes
            hideNotes() {
                this.add_notes = false
            },
            // API call to save the notes
            /**@params = value */
            async saveNotes(value) {
                this.temp_attachments = [];
                this.temp_products = [];
                this.notes.push(value)
                let response = await this.editDeals(this.$route.params.id, this.update_deal)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadNotes();
                }, 3000);
            },
            // API call to update the notes
            /**@params = value */
            async saveEditNotes(value) {
                this.temp_attachments = [];
                this.temp_products = [];
                let index = this.notes.findIndex(x => x.id == value.id)
                this.notes[index].notes = value.notes
                let response = await this.editDeals(this.$route.params.id, this.update_deal)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadNotes();
                }, 3000);
            },
            // API call to delete the notes
            /**@params = index */
            async deleteNotes(index) {
                this.temp_attachments = [];
                this.temp_products = [];
                this.notes[index].is_delete = true;
                await this.editDeals(this.$route.params.id, this.update_deal)
                this.success_msg = 'Note Deleted Successfully'
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadNotes();
                }, 3000);
            },
            //API call to upload attachment
            /**@params = newFile, @params = oldFile */
            uploadAttachment(newFile, oldFile) {
                if(this.selected_status == 'Active'){
                    var input = newFile;
                    if(this.attachments.map(x => x.name).includes(input.file.name)){
                        this.$toasted.global.error("This file already exists")
                    } else if(!input.file.name.endsWith('.htm') && !input.file.name.endsWith('.html') && !input.file.name.endsWith('.flv')){
                        this.total_file_size = this.total_file_size + input.file.size
                        if (input.file) {
                            const CancelToken = axios.CancelToken;
                            const source = CancelToken.source();
                            /**@params = name, @params = size, @params = source, @params = progress, @params = created_time, @params = error */
                            let attachment = {
                                name: input.file.name,
                                size: JSON.stringify(input.file.size),
                                source: source,
                                progress: 0,
                                created_time: new Date(),
                                error: ""
                            }
                            //checking the attachment length
                            if (this.attachments.length >= 10) {
                                this.$toasted.global.error("You're not allowed to upload more than 10 attachments")
                                this.total_file_size = this.total_file_size - input.file.size
                                }else if (this.total_file_size > 25000 * 1000){
                                    this.$toasted.global.error("Attachments Size Cannot Exceed 25mb")
                                    this.total_file_size = this.total_file_size - input.file.size
                                }else {
                                this.attachments.push(attachment);
                                this.getResumableURL(input.file, this.attachments[this.attachments.length - 1]);
                            }
                        }
                    } else {
                        this.$toasted.global.error('This file is not supported')
                    }
                } else if(this.selected_status == 'Archive') {
                    this.warning_msg = "You Cannot Upload Attachment For Archived Deal"
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 2000);
                } else if(this.selected_status == 'Closed') {
                    this.warning_msg = "You Cannot Upload Attachment For Closed Deal"
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 2000);
                }
            },
            //upload the attachments into cloud
            /**@params = file, @params = attachment */
            getResumableURL(file, attachment) {
                this.isUploadingInProgress = true;
                attachment.uploading = true;
                let data = {
                    file: attachment.name
                }
                data = new FormData()
                data.append('file', file)
                this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                        onUploadProgress: function (progressEvent) {
                            let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                                .total));
                            if (progress < 100) {
                                attachment.progress = progress;
                            }
                        }.bind(this)
                    })
                    .then(response => {
                        let resumable_url = response.data.url;
                        attachment.url = resumable_url;
                        attachment.progress = 100;
                        attachment.uploading = false;
                        delete attachment['source'];
                        setTimeout(() => {
                            this.isUploadingInProgress = false;
                            this.saveFiles();
                        }, 500);
                    })
                    .catch(error => {
                    })
            },
            //Save the files of the attachments
            async saveFiles() {
                this.temp_attachments = [];
                this.temp_products = [];
                // this.notes = [];
                this.attachments.forEach(x => {
                    this.temp_attachments.push(x)
                })
                this.temp_attachments.forEach(x => {
                    delete x['created_time']
                    delete x['deal_id_id']
                    // delete x['id']
                    delete x['error']
                    delete x['progress']
                    delete x['uploading']
                    delete x['is_delete']
                })
                let response = await this.editDeals(this.$route.params.id, this.update_deal)
                this.success_msg = "Attachment Uploaded Successfully"
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.attachments = [];
                    this.loadAttachments();
                }, 2000);
            },
            //API call to delete the product
            /**@params = index */
            async deleteProduct(index) {
                if(this.products.length == 1){
                    this.delete_disabled = true
                    setTimeout(() => {
                        this.$modal.show('OneReminder')
                    }, 500);
                }else {
                    this.delete_disabled = false
                    this.products[index].is_delete = true;
                    this.products.forEach((x, i) => {
                        if (x.product_id == this.products[index].product_id) {
                            x.is_delete = true;
                        } else {
                            x.is_delete = false;
                        }
                    })
                    this.temp_products = this.products
                    this.temp_products.forEach(x => {
                        //delete x['product_name']
                        delete x['deal_id']
                    })

                    // this.temp_attachments = [];
                    // this.notes = [];
                    // this.products[index].is_delete = true;
                    // this.products.forEach((x, i) => {
                    //     if (index == i-1) {
                    //         x.is_delete = true;
                    //     } else {
                    //         x.is_delete = false;
                    //     }
                    // })
                    // this.temp_products = this.products
                    // this.temp_products.forEach(x => {
                    //     //delete x['product_name']
                    //     delete x['deal_id']
                    // })
                    await this.editDeals(this.$route.params.id, this.update_deal)
                    this.success_msg = 'Product Deleted Successfully'
                    this.temp_products = [];
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        //this.loadDealDetails();
                        this.loadProducts();
                    }, 3000);
                }
            },
            //API call to delete the attachments
            /**@params = index */
            async deleteAttachment(index) {
                this.isUploadingInProgress = true;
                if (this.attachments[index].id == '' || this.attachments[index].id == undefined || this
                    .attachments[index].id == null) {
                    this.attachments.splice(index, 1);
                    this.isUploadingInProgress = false;
                } else {
                    this.attachments[index].is_delete = true;
                    this.temp_products = [];
                    // this.notes = [];
                    this.temp_attachments = [];
                    this.attachments.forEach(x => {
                        this.temp_attachments.push(x)
                    })
                    this.temp_attachments.forEach(x => {
                        delete x['created_time']
                        delete x['error']
                        delete x['progress']
                        delete x['content_type']
                        delete x['deal_id_id']
                        delete x['uploading']
                    })
                    let response = await this.editDeals(this.$route.params.id, this.update_deal)
                    this.success_msg = "Attachment Deleted Successfully"
                    this.temp_attachments = [];
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.isUploadingInProgress = false;
                        this.$refs.success_modal.close();
                        this.attachments = [];
                        this.loadAttachments();
                    }, 3000);
                }
            },
            //Api call to load the details of the deal
            async loadDealDetails() {
                //this.ajaxCallInProgress = true
                this.add_permission.individual = [];
                this.add_permission.team = [];
                this.permissions.individual_permission_list = [],
                this.permissions.team_permission_list = []
                let response = await this.getDealsDetails(this.$route.params.id)
                this.deal_details = response.response
                this.temp_deal_data = response.response
                this.priority = this.deal_details.priority == 'high' ? 'High' : this.deal_details.priority ==
                    'low' ? 'Low' : 'Medium'
                this.expected_close_date = this.deal_details.expected_close_date
                this.forecast_category = this.deal_details.forecast_category == 'best_case' ? 'Best Case' : this
                    .deal_details.forecast_category == 'pipeline' ? 'Pipeline' : 'Commit',
                    this.expected_revenue = this.deal_details.expected_revenue
                this.selected_status = this.deal_details.deal_status == 'active' ? 'Active' : this.deal_details
                    .deal_status == 'archive' ? 'Archive' : 'Closed'
                this.territory = this.deal_details.assigned_territory
                if (Object.keys(this.territory).length === 0 && this.territory.constructor === Object) {
                    this.territory = null
                }
                this.general_access = this.deal_details.permissions.general_access
                if(this.deal_details.permissions.individual_permission.length != 0){
                    this.permissions.individual_permission_list = this.deal_details.permissions.individual_permission
                    this.deal_details.permissions.individual_permission.forEach(el => {
                        this.add_permission.individual.push({
                            id: el.id,
                            name: el.name,
                            email: el.email_id
                        })
                    })
                }
                if(this.deal_details.permissions.team_permission.length != 0){
                    this.permissions.team_permission_list = this.deal_details.permissions.team_permission
                    this.deal_details.permissions.team_permission.forEach(el => {
                        this.add_permission.team.push({
                            id: el.id,
                            name: el.name,
                            email_id: el.email_id
                        })
                    })
                }
                if (!this.deal_details.hasOwnProperty('additional_info')) {
                    this.deal_details['additional_info'] = []
                } else {
                    this.additional_info.forEach(x => {
                        this.deal_details.additional_info.forEach(y => {
                            if (x._id == y.id) {
                                if (x.field_type == 'selection_field') {
                                    if (x.data_type == 'radio_button') {
                                        x.value = y.value
                                    } else {
                                        x.value = {
                                            value: y.value
                                        }
                                    }
                                } else {
                                    x.value = y.value
                                }
                            }
                        })
                    })
                    if (this.additional_info.length) {
                        this.check_visibility = this.additional_info.every(x => x.visibility === false)
                    }
                }
                this.searchPipelines(this.deal_details.deal_pipeline)
                this.loadNotes()
                this.loadProducts()
                this.loadAttachments()
                this.loadActionLog();
                this.load_products = false
                this.permissions_loading = false;
                this.ajaxCallInProgress = false
            },
            //Api call to load additional info
            async loadAdditionalInfo() {
                try {
                    /**@params = limit, @params = search_key, @params = skip, @params = sort_key, @params =sort_value, @params =sub_module_name */
                    let params = {
                        limit: 50,
                        search_key: "",
                        skip: 0,
                        sort_key: "",
                        sort_value: -1,
                        sub_module_name: "deals"
                    }
                    let response = await this.getAdditionalInformationList(params)
                    response.response.forEach( data =>{
                        this.temp_add_info.push(data)
                    })
                    this.additional_info = response.response
                    this.additional_info.forEach(x => {
                        if(x.value) {
                        } else  {
                            x['value'] = null
                        }
                    })
                    this.additional_info = this.additional_info.filter(x => {
                        if(x.visibility){
                            return x
                        }
                    })
                    this.additional_info = this.additional_info.filter(x => {
                        if(x.field_type == 'selection_field' && x.hasOwnProperty('options') || x.field_type == 'input_field'|| x.field_type == 'date' ){
                            return x
                        }
                    })
                    this.temp_add_info = this.temp_add_info.filter(x => {
                        if(x.visibility){
                            return x
                        }
                    })
                    this.temp_add_info = this.temp_add_info.filter(x => {
                        if(x.field_type == 'selection_field' && x.hasOwnProperty('options') || x.field_type == 'input_field'|| x.field_type == 'date' ){
                            return x
                        }
                    })

                    this.$forceUpdate()
                    this.loadDealDetails()
                    }
                catch(error) {
                }
            },
            //load the deal notes data
            /**@params = reached*/
            async loadNotes(reached) {
                this.notes = [];
                this.load_notes = true
                /**@params = id, @params = skip, @params = limit*/
                let response = await this.getDealNotes({
                    id: this.$route.params.id,
                    skip: this.notes_count,
                    limit: 50
                })
                this.notes = response.response;
                this.loadActionLog();
                this.load_notes = false
            },
            //load the deals atttachments
            /**@params = reached */
            async loadAttachments(reached) {
                this.attachments = [];
                //this.ajaxCallInProgress = true

                let response = await this.getDealAttachments({
                    id: this.$route.params.id,
                    skip: this.notes_count,
                    limit: 50
                })
                this.attachments = response.response;
                this.attachments = this.attachments.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.attachments.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.loadActionLog();
                //this.ajaxCallInProgress = false
            },
            //load the deal products data
            /**@params = reached */
            async loadProducts(reached) {
                this.products = [];
                this.load_products = true
                /**@params = id , @params = skip, @params = limit */
                let response = await this.getDealProducts({
                    id: this.$route.params.id,
                    skip: 0,
                    limit: 50
                })
                this.products = response.response;
                this.saved_products = response.response
                localStorage.setItem("AddedProducts",JSON.stringify(this.products))
                this.products.forEach(x => {
                    x['is_delete'] = true
                })

                this.loadActionLog();
                this.load_products = false
            },
            //Api call to load action log
            async loadActionLog() {
                try {
                    /**@params = id , @params = slip, @params = limit */
                    let params = {
                        id: this.$route.params.id,
                        skip: 0,
                        limit: 50,
                    }
                    let response = await this.getDealsActionLog(params);
                    this.ActionLogs = response.response
                } catch (error) {
                }
            }
        },
        computed: {
            //calculating the total transition
            total_transaction() {
                return this.products.reduce(function (result, charges) {
                    return result + charges.transaction_value;
                }, 0);
                this.$forceUpdate()
            },
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            //update the deal details
            update_deal() {
                return {
                    priority: this.priority == 'High' ? 'high' : this.priority == 'Low' ? 'low' : 'medium',
                    expected_close_date: this.expected_close_date,
                    forecast_category: this.forecast_category == 'Best Case' ? 'best_case' : this
                        .forecast_category == 'Pipeline' ? 'pipeline' : 'commit',
                    expected_revenue: this.expected_revenue,
                    products: this.temp_products,
                    attachments: this.temp_attachments,
                    notes: this.notes,
                    deal_territory_id: this.deal_details.deal_territory_id,
                    permissions: {
                        general_access: this.general_access,
                        individual_permission: this.permissions.individual_permission_list,
                        team_permission: this.permissions.team_permission_list,
                    }
                }
            },
            userPermissions() {
                return this.$store.getters.userPermissions;
            },
        },
        mounted() {
            this.ajaxCallInProgress = true
            setTimeout(() => {
                localStorage.removeItem("temp_data")
                this.loadAdditionalInfo();
            }, 500);
            this.transaction_symbol = this.loggedInUser.currency.symbol;
        },
        created(){
            this.searchIndividuals = debounce(this.searchIndividualsDebounce, 500)
            this.searchTeam = debounce(this.searchTeamDeounce, 500)
        },
    })
</script>

<style scoped>
    .w-25 {
        width: 25% !important;
    }

    .decoration-none {
        text-decoration: none !important;
    }

    .btn-bord-success {
        background-color: #fff;
        color: #008a63 !important;
        border: 1px solid #008a63;
    }

    .text-dark-blue {
        color: #00448b;
    }

    .text-dark-red {
        color: #fa0b0b
    }

    .bord-blue {
        border: 1px solid #00448b !important;
    }

    .bordrad-5px {
        border-radius: 5px !important;
    }

    .bordradtlr-5px {
        border-radius: 5px 5px 0 0 !important;
    }

    .bordradblr-5px {
        border-radius: 0 0 5px 5px !important;
    }

    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }

    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }

    .bordrad-5px {
        border-radius: 5px !important;
    }

    .header-text-heading {
        padding: 9.7px 22.2px;
        background-color: #00448b;
    }

    .scm-filters {
        width: 300px !important;
        height: 300px !important;
        right: 100px;
    }

    .icon-tick-success {
        color: #008a63;
    }

    .icon-tick-lost {
        color: #ff9a06;
    }

    .stage-sections {
        border: solid 1px #3f3f3f;
        border-radius: 4px;
        height: 350px;
        max-height: 350px;
        /*overflow: auto; */
    }

    .stage-sections .bg-blue {
        background-color: #00448b !important;
        color: #fff;
        font-weight: 500;
        padding: 10px;
        border-radius: 0px !important;
    }

    .stage-sections-right {
        border: solid 1px #3f3f3f;
        border-radius: 4px;
        height: 712px;
        max-height: 712px;
        /* overflow: auto; */
    }

    .stage-sections-right .bg-blue {
        background-color: #00448b !important;
        color: #fff;
        font-weight: 500;
        padding: 10px;
    }

    .btn-secondary:hover {
        background-color: #00448b !important;
    }

    ul {
        list-style: none;
    }

    .drag-drop-grey-bg {
        background-color: #f5f5f5;
    }

    .drag-drop-white-bg {
        background-color: #fff;
    }

    .drag_drop_cond {
        color: rgba(103, 103, 103, 0.84)
    }

    .active-deals {
        border: 0.6px solid #3b8d75 !important;
        background: #3b8d75 !important;
        border-radius: 5px;
        text-align: center;
        width: 60% !important;
        color: #fff !important;
    }

    .archive {
        border: 0.6px solid #cc9965 !important;
        background: #cc9965 !important;
        border-radius: 5px;
        text-align: center;
        width: 60% !important;
        color: #fff !important;
    }

    .closed {
        border: 0.6px solid #ed6168 !important;
        background: #ed6168 !important;
        border-radius: 5px;
        text-align: center;
        width: 60% !important;
        color: #fff !important;
    }

    .icon-tick-warning {
        color: #ff9a06;
    }

    @media screen and (max-width:992px) {
        .w-25 {
            width: 50% !important;
        }
    }

    @media (max-width: 1300px) {
        .flex-width {
            max-width: 100% !important;
            width: 100% !important;
            flex: 0 0 100% !important;
            transition: 0.5s ease all;
        }
    }

    @media screen and (max-width:992px) {
        .stage-sections-right {
            height: 383px;
        }

        .product-div {
            max-height: 252px !important;
            min-height: 252px !important;
        }

    }

    .product-div {
        min-height: 582px;
        max-height: 582px;
        overflow: auto;
    }

    .territory-content {
        padding: 0px 10px;
    }

    .inner-content-overflow {
        height: 250px;
        overflow: auto;
    }

    .territory-selected {
        color: #206ad3;
    }

    .attach-margin {
        overflow: auto
    }

    .text-flow {
        word-break: break-all
    }

    .cursor-event {
        pointer-events: none;
    }

    .select-cursor {
        pointer-events: none !important;
        color: rgb(133, 133, 133, 0.6) !important;
    }

    .btn-new-save {
        color: #fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #008a63;
    }

    .icon-direction {
        transform: translate(-60%, 20%) scale(1) rotate(320deg);
        position: absolute;
    }

    .btn-bord-lost {
        background-color: #fff;
        color: #ff9a06 !important;
        border: 1px solid #ff9a06;
    }

    .icon-hand-direction {
        transform: rotate(320deg);
        transform: scaleX(-1);
    }

    .notes-div {
        max-height: 242px;
        min-height: 242px;
        overflow: auto;
    }

    .stage-sections-right1 {
        border: solid 1px #3f3f3f;
        border-radius: 4px;
    }

    .stage-sections-right1 .bg-blue {
        background-color: #00448b !important;
        color: #fff;
        font-weight: 500;
        padding: 10px;
    }

    .overflow-auto {
        overflow: scroll !important;
    }

    .table-properties {
        border-collapse: collapse;
        width: 100%;
    }

    table thead th,
    table tbody td {
        padding: 10px;
    }

    .mx-ht {
        max-height: 309px;
    }

    .input-field {
        border-radius: 8px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        transition: 0.5s ease all;
    }

    .input-width {
        border-radius: 8px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;

        height: 48px !important;
    }

    .input-field-length {
        opacity: 0.5;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.3px;
        color: #000;
    }

    .input-label {
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #005dae;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }

    .w-200px {
        /* width: 100px; */
        max-width: 230px;
    }
    .text-flow{
        overflow-wrap:anywhere;
    }
    .icon-img{
        width: 32px;
        height: 40px;
    }
    .reset-btn {
        border: 2px solid #128809;
        line-height: 30px;
        border-radius: 18px;
        background-color: #128809;
        color: #fff;
        font-weight: 600;
        padding: 0px 12px;
        cursor: pointer;
    }
    .pointer-events{
        cursor: not-allowed !important;
        pointer-events: none !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Deals/DealDetails.vue